module.exports = __webpack_public_path__ + "48b8b2145e20eea61ae3fdf2c9902ee8.png";